<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.99967 2.33301V1.33301M3.37345 3.37345L2.66634 2.66634M3.37345 8.66634L2.66634 9.37345M8.66634 3.37345L9.37345 2.66634M2.33301 5.99967H1.33301M5.66634 5.66634L8.40708 14.1849L10.333 12.2589L12.7404 14.6663L14.6663 12.7404L12.2589 10.333L14.1849 8.40708L5.66634 5.66634Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
